// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabs":"tabs__tabs___1-9Q_","tab":"tabs__tab___2dU3P","active":"tabs__active___1CelH","button":"tabs__button___15JzD","label":"tabs__label___4nlQr","icon":"tabs__icon___2WzoI"};
    if(module.hot) {
      // 1792636851086
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  